<!-- <div class="form-group form-group--sm-lg">
<div class="custom-yesno">
  <span class="custom-yesno__label">
    {{question?.email_version}}
  </span>
  <div class="custom-yesno__controls">
    <label class="custom-yesno__control" *ngFor="let option of items; let i=index;">
      <input type="radio"
        [checked]="option.answer === question.answer"
        [name]="uniqueControlName"
        [disabled]="readOnly"
        (click)="checkRadio(option)"
        [value]="option.answer">
        <span class="custom-yesno__indi">{{ option.answer.slice(0, 6)}}</span>
      </label>
    </div>
  </div>
</div>
<aside class="question-fyi mt-15 mb-25 collapse" [ngClass]="itk ? 'show':null" id="fyi-1">
  <div class="question-fyi__icon">
    <img src="/assets/1/icn/message-avatar.svg" class="icon">
  </div>
  <div class="question-fyi__content">
    <h6>Important to know</h6>
    <p [innerHTML]="itk"></p>
  </div>
</aside> -->

<div class="form-group">
  <div class="tile tile--binary">
    @for (option of items; track option) {
      <input type="radio"
        [name]="uniqueControlName"
        [value]="option.answer"
        [attr.data-value]="(option.answer || '').trim().toLowerCase()"
        [id]="uniqueControlName + '-' + option.answer"
        [checked]="option.answer === question?.answer"
        [disabled]="readOnly"
        (click)="checkRadio(option)">
      }
      <div class="tile__inner">
        <div class="tile__main">
          <div class="tile__content">
            <div class="tile__label">
              <div class="tile__title">{{ question?.question_copy || question?.email_version }}</div>
              @if (question?.question_comment) {
                <div class="tile__subtitle">{{ question?.question_comment }}</div>
              }
            </div>
          </div>
          <div class="tile__binary">
            @for (option of items; track option) {
              <label
                [class]="'tile__binary-' + option.answer.toLowerCase().slice(0, 3)"
                [for]="uniqueControlName + '-' + option.answer">
                <span class="tile__binary-label">{{ option.answer | titlecase }}</span>
              </label>
            }
          </div>
        </div>
        <div class="tile__drawer">
          <app-itk
            [content]="itk"
            [id]="uniqueControlName + '-itk'"
            [linked]="true"
            [active]="!!question?.answer && !!itk">
          </app-itk>
        </div>
      </div>
    </div>
  </div>